import React from "react";
import Card from "../components/Apply/Card";
import MainText from "../components/Apply/MainText";
import MainTitle from "../components/Apply/MainTitle";
import IntroButton from "../components/Buttons/IntroButton";
import WantToApplyButton from "../components/Buttons/WantToApplyButton";
import { useTheme } from "@mui/styles";
import { Box } from "@mui/material";
import BackButton from "../components/ApplyForm/BackButton";
import { useLocation } from "react-router-dom";
import useTranslation from "../hooks/useTranslation";

const useStyles = (theme) => ({
  span: { fontWeight: "bold" },
  cardsContainer: {
    display: "flex",
    alignItems: "center",
    flexDirection: { xs: "column", md: "row" },
    justifyContent: { md: "center" },
    mt: { md: "117px" },
    mb: { xs: "70px", md: "102px" },
  },
  jsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonContainer: {
    width: { xs: "594px", md: "650px", lg: "1000px", xl: "1060px" },
    mt: "-5rem",
    mb: "4rem",
    display: "flex",
    justifyContent: {
      xs: "center",
      sm: "center",
      md: "flex-start",
      lg: "flex-start",
      xl: "flex-start",
    },
  },
});

const ApplyJavascript = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { pathname } = useLocation();
  const {
    title,
    description,
    img,
    question,
    negativeAnswer,
    affirmativeAnswer,
  } = useTranslation(pathname, "ApplyJavascript");

  return (
    <>
      <MainTitle
        title={title}
        subtitle={
          <>
            {description[0]}
            <span style={classes.span}>{description[1]}</span>
          </>
        }
        img={img}
        scroll={true}
      />
      <Box>
        <MainText
          text={question}
          mt={{ xs: "-118px", md: "-90px", lg: "-83px", xl: "-100px" }}
        />
      </Box>
      <Box sx={classes.jsContainer}>
        <Box sx={classes.cardsContainer}>
          <Card
            icons={negativeAnswer.icons}
            mainText={
              <>
                <span style={classes.span}>{negativeAnswer.text[0]}</span>
                {negativeAnswer.text[1]}
                <br />
                {negativeAnswer.text[2]}
              </>
            }
            secondaryText={negativeAnswer.disclaimer}
            button={
              <IntroButton
                mainColor="#f32c4d"
                secondaryColor="#d00e2e"
                iconColor="#ff012b"
                mt={{ xs: "19px", md: "", lg: "55px" }}
                navigateTo="/intro"
                height={{
                  xs: "52px",
                  sm: "42.25px",
                  md: "46.5px",
                  lg: "60px",
                  xl: "64px",
                }}
              />
            }
            mt={{ xs: "12px", md: "27px" }}
            mr={{ md: "37px" }}
          />

          <Card
            icons={affirmativeAnswer.icons}
            mainText={
              <>
                <span style={classes.span}>{affirmativeAnswer.text[0]}</span>
                {affirmativeAnswer.text[1]}
                <br />
                {affirmativeAnswer.text[2]}
              </>
            }
            secondaryText={affirmativeAnswer.disclaimer}
            button={
              <WantToApplyButton
                navigateTo="/aplica/javascript/fechas"
                mainColor="#fbbf30"
                secondaryColor="#eda135"
                iconColor="#fbbf30"
                mt={{ xs: "32px", md: "", lg: "55px" }}
                height={{
                  xs: "52px",
                  sm: "42.25px",
                  md: "46.5px",
                  lg: "60px",
                  xl: "64px",
                }}
              />
            }
            mt={{ xs: "27px" }}
          />
        </Box>
        <Box sx={classes.buttonContainer}>
          <BackButton />
        </Box>
      </Box>
    </>
  );
};

export default ApplyJavascript;
